import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';


const baseUrl = `${process.env.VUE_APP_API_URL}/user/messages`;

export const useUserMessageStore = defineStore({
    id: 'userMessage',
    state: () => ({
        messages: [],
        userMessage: '',
    }),
    actions: {
        async fetchAll() {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + '?account_id=' + accountId, null);
            this.messages = response.data;
        },

        async addMessage() {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            await fetchWrapper.post(`${baseUrl}` + '?account_id=' + accountId, {
                'text': this.userMessage,
            });
            this.userMessage = '';
            await this.fetchAll();
        }
    }
});
